import axios, { isAxiosError } from 'axios';
import { userIamUrl } from '@/config/user-iam';
const CHANGE_PASSWORD_URL = () => userIamUrl('/user-management/api/account/change-password');
function parseChangePasswordError(err) {
    if (!isAxiosError(err)) {
        return err instanceof Error ? err.message : 'Could not change password.';
    }
    const data = err.response?.data;
    if (Array.isArray(data?.fieldErrors) && data.fieldErrors.length > 0) {
        return data.fieldErrors
            .map((fe) => fe.message || fe.field || 'Validation error')
            .join(' · ');
    }
    if (typeof data?.message === 'string' && data.message.trim()) {
        return data.message.trim() === 'error.validation'
            ? 'Current password is incorrect or the new password is not valid.'
            : data.message.trim();
    }
    if (typeof data?.detail === 'string' && data.detail.trim()) {
        return data.detail.trim();
    }
    if (typeof data?.title === 'string' && data.title.trim()) {
        return data.title.trim();
    }
    if (err.response?.status === 401) {
        return 'Current password is incorrect.';
    }
    return err.message || 'Could not change password.';
}
/** POST `/user-management/api/account/change-password` — IAM account password change for the signed-in user. */
export async function changeAccountPassword(payload) {
    const currentPassword = payload.currentPassword.trim();
    const newPassword = payload.newPassword.trim();
    if (!currentPassword) {
        throw new Error('Current password is required.');
    }
    if (!newPassword) {
        throw new Error('New password is required.');
    }
    try {
        await axios.post(CHANGE_PASSWORD_URL(), { currentPassword, newPassword }, { headers: { Accept: 'application/json', 'Content-Type': 'application/json' } });
    }
    catch (e) {
        throw new Error(parseChangePasswordError(e));
    }
}
